import en from './en'

// NOTE: DO NOT UPDATE THIS RESERVED TRANSLATION KEYS AND THEIR VALUES
const reservedTranslationsWithUniqueKeyNames = {
  '404': '404',
  leadingSpaceNotAllowed: 'Espaço no início não é permitido.',
  trailingSpaceNotAllowed: 'Espaço no final não é permitido.',
  mustbeAtleastCharacters: '{{label}} deve ter pelo menos {{minNumber}} caracteres',
  cannotExceedCharacters: '{{label}} não pode exceder {{maxNumber}} caracteres',
  numberMustbeAtleast: '{{label}} deve ser pelo menos {{minNumber}}',
  numberCannotExceed: '{{label}} não pode exceder {{maxNumber}}',
  isRequired: '{{label}} é obrigatório',
  emptySpaceNotContain: 'Este campo não pode conter espaço',
  register: 'Cadastrar',
  login: 'Entrar',
  comingSoon: 'Em breve',
  submit: 'Enviar',
  email: 'E-mail',
  termsConditions: 'Termos e condições',
  password: 'Senha',
  eighteenPlus: 'Tenho mais de 18 anos e concordo com os Termos de Serviço',
  signUp: 'Cadastrar',
  createNewAccount: 'Criar nova conta',
  fullName: 'Nome completo',
  referralCode: 'Código de indicação',
  confirmPassword: 'Confirmar senha',
  facebook: ' Facebook',
  google: 'Google',
  haveAnAccount: 'Já tem uma conta? ',
  pageNotFound: 'Não encontramos a página que você procura!',
  error: 'Erro',
  somethingWentWrong: 'Algo deu errado!',
  personalDetails: 'Dados pessoais',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  dateOfBirth: 'Data de nascimento',
  phoneNumber: 'Número de telefone',
  change: 'Alterar',
  saveChanges: 'Salvar alterações',
  currentPassword: 'Senha atual',
  newPassword: 'Nova senha',
  myProfile: 'Meu perfil',
  transactions: 'Transações',
  deposit: 'Depositar',
  withdraw: 'Sacar',
  referral: 'Indicação',
  changePassword: 'Alterar senha',
  logout: 'Sair',
  currency: 'Moeda.',
  view: 'Ver',
  ok: 'OK',
  cancel: 'Cancelar',
  userName: 'Nome de usuário',
  passwordRegexMatch: 'A senha deve conter uma letra maiúscula, um número e um caractere especial',
  invalidEmailFormat: 'Formato de e-mail inválido',
  noRecordsFound: 'Nenhum registro encontrado',
  backToLobby: 'Voltar ao lobby',
  placeBet: 'Fazer aposta',
  rOICalculator: 'Calculadora de ROI',
  activeBets: 'APOSTAS ATIVAS',
  closedBets: 'APOSTAS FECHADAS',
  publicBets: 'APOSTAS PÚBLICAS',
  leaderboard: 'CLASSIFICAÇÃO',
  howToplay: 'Como jogar',
  bustPriceLabel: 'Preço de bust',
  multiplierLabel: 'MULTIPLICADOR',
  pnLFee: 'Taxa de PnL',
  flatFee: 'Taxa fixa',
  takeProfitLabel: 'REALIZAR LUCRO NO PREÇO',
  closeBetLabel: 'FECHAR APOSTA NO PREÇO',
  priceUpLabel: 'O PREÇO VAI SUBIR OU CAIR?',
  payoutMul: 'MULTIPLICADOR DE PAGAMENTO',
  allCurrencies: 'Todas as moedas',
  monthLabel: 'Mês',
  day: 'Dia',
  week: 'Semana',
  betLabel: 'Rótulo da aposta',
  entryPrice: 'Preço de entrada',
  closeBetErr: 'Informe um valor válido para fechar a aposta',
  mulValErr: 'Valor do multiplicador entre 100 e 1000',
  profitErr: 'Informe um valor válido de realização de lucro'
}

// NOTE: PLEASE ADD YOUR API SUCCESS MESSAGE TRANSLATIONS HERE ONLY
const apiSuccessMessagesTranslations = {
  loginSuccessfully: 'Login realizado com sucesso.',
  logoutSuccessfully: 'Logout realizado com sucesso.',
  passwordUpdateSuccessfully: 'Senha atualizada com sucesso.',
  updatePlayerStatusSuccessfully: 'Status do jogador atualizado com sucesso.',
  resetPasswordSuccessfully: 'Senha redefinida com sucesso.',
  signupSuccessfully: 'Cadastro realizado com sucesso.',
  betPlacedSuccessfully: 'Aposta realizada com sucesso.',
  betCancelledSuccessfully: 'Aposta cancelada com sucesso.'
}

// NOTE: PLEASE ADD YOUR API ERROR MESSAGE TRANSLATIONS HERE ONLY
const apiErrorMessagesTranslations = {
  UnAuthorized: 'Sua sessão expirou',
  LoginFailedError: 'Falha no login',
  InvalidCredentialsError: 'Credenciais inválidas',
  InvalidTokenError: ' O token não é válido',
  InvalidSessionError: ' Sessão expirada',
  CreateUserError: 'O usuário não pode ser criado',
  DataMismatchError: 'Os dados não correspondem',
  UserNotFoundError: 'Usuário não encontrado',
  DuplicateEmailError: 'O e-mail já existe',
  RequestInputValidationError: 'Verifique os dados da solicitação',
  ResponseInputValidationError: 'A validação da resposta falhou, consulte o esquema JSON da resposta',
  SocketRequestInputValidationError: 'Verifique os dados da solicitação para a comunicação por socket',
  SocketResponseValidationError: 'A validação da resposta da comunicação por socket falhou, consulte o esquema JSON da resposta',
  InternalServerError: 'Erro interno do servidor',
  InvalidSocketArgumentError: 'Forneça os argumentos corretos: eventName, [payloadObject] e [callback]',
  InvalidCredentials: 'As credenciais não correspondem',
  InvalidToken: 'O token de acesso não foi enviado ou expirou',
  InvalidSession: 'A sessão do usuário não é válida, faça login novamente',
  InvalidAccess: 'Permissão negada',
  NonOperationalError: 'Ocorreu um erro no servidor',
  UserNotExists: 'O usuário não existe',
  InvalidAction: 'Ação inválida',
  SessionAlreadyStarted: 'Sessão já iniciada',
  SessionNotStarted: 'Sessão não iniciada',
  EmailNotVerified: 'E-mail não verificado',
  InvalidGameTypeError: 'Nenhuma configuração encontrada para o tipo de jogo informado',
  InvalidGameRoundError: 'Nenhum jogo encontrado para os detalhes informados',
  NoRoundRunningError: 'Nenhuma rodada está em andamento no momento',
  NoPlacedBetFoundError: 'Nenhuma aposta realizada encontrada',
  NoWalletFoundError: 'Carteira não encontrada com os dados especificados',
  NotEnoughBalanceError: 'O saldo não é suficiente para realizar a operação',
  AutoRateIsInvalidError: 'A taxa automática não está dentro do limite válido',
  BetAmountIsNotInLimitError: 'O valor da aposta não está dentro dos limites válidos',
  EmailNotFound: 'E-mail não encontrado',
  UserNotAbove18YearsError: 'O usuário não tem mais de 18 anos',
  InvalidBlockchainAddress: 'Endereço de blockchain inválido',
  AddressMismatch: 'O endereço informado e o endereço recuperado não correspondem',
  NonceLifetimeExpired: 'Validade do nonce expirada',
  SomethingWentWrong: 'Algo deu errado',
  AccountNotActive: 'A conta não está ativa',
  LoginTokenRequire: 'OTP (senha de uso único) é obrigatório',
  UserAlreadyExists: 'O usuário já existe',
  InvalidVerificationToken: 'Token de verificação inválido',
  UserNotActive: 'O usuário está bloqueado, entre em contato com o administrador',
  FileUploadFailed: 'Falha no envio da imagem',
  EmailAlreadyVerified: 'O e-mail já foi verificado',
  InvalidReferralCode: 'Código de indicação inválido',
  InvalidAffiliateCode: 'Código de afiliado inválido',
  RecordNotFound: 'Registro não encontrado',
  WithdrawalRequestAlreadyPending: 'Já existe uma solicitação de saque pendente',
  WalletDoesNotBelongToUser: 'Esta carteira não pertence a este usuário',
  BetAlreadyInProgress: 'A aposta já está em andamento',
  ServerSeedNotFoundErrorType: 'Seed do servidor não encontrada, faça login novamente',
  InvalidTileErrorType: 'A casa deve estar no intervalo de 1 a 25',
  FavoriteGameExistsErrorType: 'O jogo favorito já existe',
  FavoriteGameNotFoundErrorType: 'Jogo favorito não encontrado',
  TransactionAlreadyPendingErrorType: 'A transação já está pendente',
  UserHasNoActiveBonusErrorType: 'O usuário não tem bônus ativo',
  BonusExpiredErrorType: 'O bônus expirou',
  UserHasAlreadyActivatedBonusWageringErrorType: 'O usuário já ativou o requisito de apostas do bônus',
  InvalidRoundHashErrorType: 'Hash da rodada incorreto',
  InvalidSignatureErrorType: 'Assinatura incorreta',
  UserHasNoBonusAmountToClaimErrorType: 'O usuário não tem valor de bônus para resgatar',
  BonusNotExistsErrorType: 'Bônus não encontrado'
}

// NOTE: PLEASE ADD YOUR OTHER KEY TRANSLATIONS HERE ONLY
const otherTranslationKeys = {
  betAmount: 'Valor da aposta',
  betHistory: 'Histórico de apostas',
  provablyFair: 'Comprovadamente justo',
  minimumBet: 'Aposta mínima',
  maximumBet: 'Aposta máxima',
  selectYourBetAmount: 'Selecione o valor da sua aposta',
  buyInAmount: 'Valor do buy-in',
  selectYourBuyInAmountFromGivenRange: 'Selecione o valor do buy-in na faixa indicada',
  profitOnWin: 'Lucro em caso de vitória',
  noOfBets: 'Número de apostas',
  auto: 'Auto',
  half: '½',
  double: '2X',
  start: 'Iniciar',
  cancel: 'Cancelar',
  prediction: 'Previsão',
  luckyNumber: 'Número da sorte',
  multiplier: 'Multiplicador',
  chanceToWin: 'Chance de ganhar',
  betBtn: 'Fazer aposta',
  bets: 'Apostas',
  depositBtn: 'Depositar',
  rollOver: 'Acima',
  rollUnder: 'Abaixo',
  invalidBetAmount: 'Valor de aposta inválido',
  maxBetAmountLimit: 'Limite máximo de aposta {{value}} excedido',
  minBetAmountLimit: 'A aposta mínima é {{value}}.',
  noBalance: 'O valor da aposta é maior que o saldo da carteira',
  noAutoCashout: 'A taxa automática é obrigatória.',
  autoRateLimitWarning: 'A taxa automática deve ser maior que {{value}}'
}

// NOTE: PLEASE ADD YOUR PREDICTION MARKET TRANSLATIONS HERE ONLY
const predictionMarketTranslations = {
  error: 'Erro',
  somethingWentWrongPleaseTryAgain: 'Algo deu errado. Tente novamente.',
  market: 'Mercado',
  limit: 'Limite',
  buy: 'Comprar',
  sell: 'Vender',
  yes: 'Sim',
  no: 'Não',
  up: 'Sobe',
  down: 'Desce',
  yesCents: 'Sim {{cents}}¢',
  noCents: 'Não {{cents}}¢',
  split: 'Split',
  merge: 'Mesclar',
  amount: 'Valor',
  shares: 'Cotas',
  cancel: 'Cancelar',
  submit: 'Enviar',
  refresh: 'Atualizar',
  loading: 'Carregando',
  loadMore: 'Carregar mais',
  gotIt: 'Entendi',
  next: 'Próximo',
  previous: 'Anterior',
  trade: 'Negociar',
  portfolio: 'Portfólio',
  rules: 'Regras',
  volume: 'Volume',
  category: 'Categoria',
  notAvailable: 'N/D',
  open: 'Aberto',
  closed: 'Fechado',
  removed: 'Removido',
  resolved: 'Resolvido',
  cancelled: 'Cancelado',
  settled: 'Liquidado',
  ask: 'Ask',
  bid: 'Bid',
  asks: 'Asks',
  bids: 'Bids',
  total: 'Total',
  outcome: 'Resultado',
  options: 'Opções',
  history: 'Histórico',
  positions: 'Posições',
  orders: 'Ordens',
  activity: 'Atividade',
  comments: 'Comentários',
  delete: 'Excluir',
  reply: 'Responder',
  postComment: 'Publicar comentário',
  likeCount: 'Curtir ({{count}})',
  limitPrice: 'Preço limite',
  postOnly: 'Somente publicação',
  youPay: 'Você paga',
  shareCost: 'Custo das cotas',
  toWin: 'A ganhar',
  youWillReceive: 'Você receberá',
  averagePrice: 'Preço médio',
  payable: 'A pagar',
  processingFee: 'Taxa de processamento',
  processingFees: 'Taxas de processamento',
  estProcessingFee: 'Taxa de processamento est.',
  estProcessingFeeIncluded: 'Taxa de processamento est. (incluída)',
  processingFeeRefundable: 'Taxa de processamento (reembolsável)',
  showMore: 'mostrar mais...',
  feePerShareIfItFillsNow: 'Taxa por cota se for executada agora',
  marketSettled: 'Mercado liquidado',
  resultDeclared: 'Resultado declarado',
  tradingClosedForThisOption: 'A negociação está fechada para esta opção.',
  waitingForNextMarket: 'Ainda não há mercado ao vivo. A negociação abre quando a próxima janela começar.',
  cryptoLiveNavLabel: 'Live Crypto',
  goBack: 'Voltar',
  yourPosition: 'Sua posição',
  availableToTrade: 'Disponível para negociar',
  locked: 'Bloqueado',
  profitLoss: 'L/P',
  yesShares: 'Cotas Sim',
  noShares: 'Cotas Não',
  avgYesPrice: 'Preço médio Sim',
  avgNoPrice: 'Preço médio Não',
  outcomeShares: 'Cotas {{outcome}}',
  avgOutcomePrice: 'Preço médio de {{outcome}}',
  payoutProfitLoss: 'L/P do pagamento',
  outcomeWon: '{{outcome}} venceu',
  buyOutcome: 'Comprar {{outcome}}',
  sellOutcome: 'Vender {{outcome}}',
  decreaseAmount: 'Diminuir valor',
  increaseAmount: 'Aumentar valor',
  decreaseShares: 'Diminuir cotas',
  increaseShares: 'Aumentar cotas',
  decreaseLimitPrice: 'Diminuir preço limite',
  increaseLimitPrice: 'Aumentar preço limite',
  nobodySellingRightNow: 'Ninguém está vendendo agora. Tente uma ordem limitada para que a sua possa esperar.',
  nobodyBuyingRightNow: 'Ninguém está comprando agora. Tente uma ordem limitada para que a sua possa esperar.',
  tooMuchMaxBuy: 'Valor alto demais. O máximo que você pode comprar agora é {{amount}}$.',
  tooManySharesMaxSell: 'Cotas demais. O máximo que você pode vender agora é {{amount}}.',
  restAsMakerOnly: 'Permanece apenas como maker; rejeitada se tomaria liquidez',
  mergeMatchedSharesIntoCollateral: 'Mesclar cotas Sim e Não correspondentes de volta em garantia.',
  sharesPerSide: 'Cotas (por lado)',
  splitCollateralIntoShares: 'Dividir a garantia em cotas Sim e Não para este mercado.',
  closeTradePanel: 'Fechar painel de negociação',
  openTradePanel: 'Abrir painel de negociação',
  orderSummary: 'Resumo da ordem',
  youSell: 'Você vende',
  youMerge: 'Você mescla',
  estProceedsAtMarket: 'Receita est. a mercado',
  splitCollateral: 'Dividir garantia',
  mergeShares: 'Mesclar cotas',
  splitHasNoProcessingFee: 'O split não tem taxa de processamento.',
  mergeHasNoProcessingFee: 'A mesclagem não tem taxa de processamento.',
  includedInWhatYouPay: 'Incluído no que você paga. Aplica-se quando sua ordem encontra ofertas disponíveis.',
  deductedFromWhatYouReceive: 'Deduzido do que você recebe quando sua ordem encontra bids disponíveis.',
  heldWithYourOrder: 'Retido com sua ordem. Reembolsado se ela esperar no livro. Mantido apenas se for executada na hora.',
  onlyIfOrderFillsRightAway: 'Somente se sua ordem for executada na hora — deduzido da receita. Sem taxa se ela esperar no livro.',
  makerFeeRebateExplanation: 'Se outra pessoa tomar sua ordem em espera, você pode ganhar {{rebatePercent}}% da taxa dela.',
  postOnlyOrderExplanation: 'Somente publicação: esta ordem apenas espera. Se fosse executada na hora, ela é cancelada e você recebe o dinheiro de volta.',
  notEnoughMoneyInWallet: 'Dinheiro insuficiente na sua carteira.',
  notEnoughYesAndNoSharesToMerge: 'Cotas Sim e Não insuficientes para mesclar.',
  notEnoughSharesToSell: 'Você não tem tantas cotas para vender.',
  maxOrderSizeIs: 'O tamanho máximo da ordem é {{amount}}.',
  orderCrossesOwnSellOrder: 'A ordem cruzaria sua própria ordem de venda neste resultado. Cancele ou reduza essa venda primeiro.',
  orderCrossesOwnOppositeBuy: 'A ordem cruzaria sua própria compra do lado oposto (Sim+Não >= 100¢). Cancele ou ajuste essa ordem primeiro.',
  orderCrossesOwnBuyOrder: 'A ordem cruzaria sua própria ordem de compra neste resultado. Cancele ou aumente essa compra primeiro.',
  placedBuyLimitOrder: 'Ordem limitada de compra de {{shares}} cotas ao preço {{price}} enviada',
  placedSellLimitOrder: 'Ordem limitada de venda de {{shares}} cotas ao preço {{price}} enviada',
  placedBuyMarketOrder: 'Ordem a mercado de compra no valor {{amount}} enviada',
  placedSellMarketOrder: 'Ordem a mercado de venda de {{shares}} cotas enviada',
  mergedYesAndNoShares: '{{quantity}} cotas sim e não mescladas no valor {{amount}}',
  splitAmountIntoYesAndNoShares: 'Valor {{amount}} dividido em {{yesShares}} cotas sim e {{noShares}} cotas não',
  closedBuyLimitOrder: 'Ordem limitada de compra de {{remainingShares}} cotas ao preço {{price}} encerrada, total {{shares}}',
  closedSellLimitOrder: 'Ordem limitada de venda de {{remainingShares}} cotas ao preço {{price}} encerrada, total {{shares}}',
  closedBuyMarketOrder: 'Ordem a mercado de compra no valor {{remainingAmount}} encerrada, total {{amount}}',
  closedSellMarketOrder: 'Ordem a mercado de venda de {{remainingShares}} cotas encerrada, total {{shares}}',
  boughtSharesFromSeller: '{{quantity}} cotas compradas ao preço {{price}} de {{sellerName}}',
  soldSharesToBuyer: '{{quantity}} cotas vendidas ao preço {{price}} para {{buyerName}}',
  marketResolvedWithOutcome: 'Mercado resolvido com o resultado {{outcome}}. Pagamento: ${{payout}} ({{winningShares}} cotas vencedoras).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} recebeu {{quantity}} cotas a {{price}} (emitidas pelo sistema)',
  buyerBoughtSharesFromSeller: '{{buyerName}} comprou {{quantity}} cotas a {{price}} de {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} vendeu {{quantity}} cotas a {{price}} para SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} vendeu {{quantity}} cotas a {{price}} para {{buyerName}}',
  notifications: 'Notificações',
  unreadNotifications: '{{count}} notificações não lidas',
  recentCount: '{{count}} recentes',
  loadingNotifications: 'Carregando notificações...',
  noNotificationsYet: 'Ainda não há notificações. Você será avisado quando ordens forem correspondidas, concluídas ou mercados forem resolvidos.',
  activityUpdate: 'Atualização de atividade',
  marketResolved: 'Mercado resolvido',
  marketQuestionResolved: 'O mercado "{{questionTitle}}" foi resolvido.',
  walletUpdated: 'Carteira atualizada',
  justNow: 'Agora mesmo',
  pickAMarket: 'Escolha um mercado',
  pickAMarketDescription: 'Abra qualquer mercado e escolha Sim ou Não com base na sua previsão. Depois use o painel de ordens para obter cotas.',
  preferLimitOrders: 'Prefira ordens limitadas',
  preferLimitOrdersDescription: 'Comece aqui. Defina o preço exato (¢) e o número de cotas. Sua ordem fica no livro até alguém correspondê-la — assim você controla o preço.',
  noFillUseSplit: 'Sem execução? Use Split',
  noFillUseSplitDescription: 'Se não houver liquidez suficiente para executar uma ordem limitada, divida sua garantia em cotas Sim e Não iguais. Depois você pode vender o lado que não quer.',
  needSpeedMarketOrders: 'Precisa de velocidade? Ordens a mercado',
  needSpeedMarketOrdersDescription: 'Ordens a mercado são executadas na hora contra o livro atual. Use-as quando quiser cotas agora e aceitar pagar o preço de mercado.',
  holdOrCashOut: 'Manter ou sacar',
  holdOrCashOutDescription: 'Venda a qualquer momento antes da resolução ou mantenha até a liquidação. Cotas vencedoras pagam US$ 1 cada; cotas perdedoras são liquidadas a US$ 0.',
  restsOnTheBookUntilMatched: 'Fica no livro até ser correspondida',
  convertCashIntoYesAndNoShares: 'Converter dinheiro em cotas Sim + Não',
  estShares: 'Cotas est.',
  fillsInstantlyAtBookPrices: 'Executa na hora aos preços do livro',
  resolvedYes: 'Resolvido · Sim',
  payoutCredited: 'Pagamento creditado',
  closeHowItWorks: 'Fechar como funciona',
  tryItOut: 'Experimentar?',
  willThereBeAUsRecessionThisYear: 'Haverá uma recessão nos EUA este ano?',
  exitTutorialAndReturnToMarkets: 'Sair do tutorial e voltar aos mercados',
  exitDemo: 'Sair da demo',
  howItWorks: 'Como funciona',
  demoGuide: 'Guia',
  demoGuideReopen: 'Reabrir guia da demo',
  demoGuideSkip: 'Pular guia',
  demoGuideFinish: 'Concluir',
  demoGuideStepOf: 'Etapa {{current}} de {{total}}',
  demoGuideBack: 'Voltar',
  demoGuideWelcomeTitle: 'Bem-vindo ao playground',
  demoGuideWelcomeBody: 'Este é um mercado demo seguro com dinheiro fictício. Vou apontar cada parte da interface e explicar o que ela faz — experimente a ação se quiser ou toque em Próximo a qualquer momento.',
  demoGuideWelcomeHint: 'Você começa com US$ 1000 de saldo demo. Nada aqui é real.',
  demoGuideLimitTitle: 'Prefira ordens limitadas',
  demoGuideLimitBody: 'Uma ordem limitada permite definir o preço exato (¢) e o número de cotas. Ela fica no livro até alguém correspondê-la — você controla o preço em vez de aceitar o que está ativo.',
  demoGuideLimitHint: 'Abri Limite e sugeri Comprar Sim a 45¢ × 10. Envie se quiser tentar ou Próximo para continuar lendo.',
  demoGuideOrderbookTitle: 'Sua ordem no livro',
  demoGuideOrderbookBody: 'O livro de ordens mostra bids e asks em espera. Quando você envia uma ordem limitada, ela aparece aqui (muitas vezes marcada como Você) até ser executada ou cancelada.',
  demoGuideOrderbookHint: 'Se você ainda não tem uma ordem em espera, coloco um pequeno bid demo para você ver como fica.',
  demoGuidePostOnlyTitle: 'Somente publicação (apenas maker)',
  demoGuidePostOnlyBody: 'Somente publicação significa que sua compra limitada apenas espera como maker. Se o preço fosse executado imediatamente contra um ask, a ordem é rejeitada e seu dinheiro volta — útil quando você nunca quer tomar liquidez.',
  demoGuidePostOnlyHint: 'Somente publicação está marcado com um bid de 45¢ que não cruza. Tente enviar ou Próximo para continuar.',
  demoGuideCancelTitle: 'Cancelar uma ordem em espera',
  demoGuideCancelBody: 'Mudou de ideia? As ordens abertas ficam em Minha posição. Cancelar libera o dinheiro reservado nas compras (ou as cotas bloqueadas nas vendas) para você reutilizar.',
  demoGuideCancelHint: 'Use Cancelar em uma linha se quiser praticar — mantenho um bid em espera disponível para você.',
  demoGuideMarketTitle: 'Precisa de velocidade? Ordens a mercado',
  demoGuideMarketBody: 'Ordens a mercado são executadas na hora contra o livro atual. Use-as quando quiser cotas agora e aceitar pagar os preços ask ao vivo em vez de esperar seu limite.',
  demoGuideMarketHint: 'Defini uma compra de US$ 5 em Mercado. Envie para ver uma execução instantânea ou Próximo para seguir.',
  demoGuideMintTitle: 'Sem asks? A emissão ainda funciona',
  demoGuideMintBody: 'Se ninguém estiver vendendo, você ainda pode obter cotas. O mecanismo pode emitir Sim+Não a partir da garantia ao corresponder sua compra a um bid do lado oposto — asks vazios nem sempre significam “travado”.',
  demoGuideMintHint: 'Limpei os asks desta opção. Uma compra a mercado de US$ 5 está pronta — veja as cotas aparecerem mesmo com o lado ask vazio.',
  demoGuideSplitTitle: 'Sem execução? Use Split',
  demoGuideSplitBody: 'O split transforma a garantia em cotas Sim e Não iguais na hora — sem contraparte. Útil quando o livro está fino e você quer estoque para vender depois o lado que não deseja.',
  demoGuideSplitHint: 'Sugeri dividir US$ 10. Experimente para ver Sim e Não subirem ou Próximo para continuar.',
  demoGuideMergeTitle: 'Mesclar de volta para dinheiro',
  demoGuideMergeBody: 'Mesclar é o inverso do split: queimar cotas Sim e Não iguais para receber a garantia de volta. Útil quando você tem os dois lados e quer voltar para dinheiro.',
  demoGuideMergeHint: 'Sugeri mesclar 5 por lado. Você precisa de Sim e Não disponíveis correspondentes — faça split antes, se necessário.',
  demoGuideResolveTitle: 'Fechar e liquidar',
  demoGuideResolveBody: 'Quando a negociação termina, o mercado fecha e depois é liquidado. Cotas vencedoras pagam US$ 1 cada; cotas perdedoras são liquidadas a US$ 0. Na demo, Gerenciar mercado permite simular fechar → escolher um vencedor → liquidar.',
  demoGuideResolveHint: 'Abra o painel se não estiver aberto. Feche primeiro, depois escolha Sim/Não e Liquidar para a opção selecionada.',
  demoGuideDoneTitle: 'Você já tem o básico',
  demoGuideDoneBody: 'Limite para controlar o preço, somente publicação para permanecer maker, cancelar para liberar fundos reservados, mercado para velocidade, emissão quando os asks estão vazios, split/mesclagem para estoque e gerenciar mercado para a resolução.',
  demoGuideDoneHint: 'Repita quando quiser pelo botão Guia. O dinheiro demo é redefinido ao entrar novamente no modo demo.',
  demoGuideWaitingForAction: 'Conclua a ação destacada para continuar.',
  demoGuideDoThisFirst: 'Faça isto primeiro',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Em alta',
  new: 'Novo',
  buyYes: 'Comprar Sim',
  breaking: 'Urgente',
  noBreakingMarketsRightNow: 'Nenhum mercado urgente no momento.',
  backToMarkets: 'Voltar aos mercados',
  markets: 'Mercados',
  openFullMarket: 'Abrir mercado completo',
  tradeMarket: 'Negociar mercado',
  previousMarket: 'Mercado anterior',
  nextMarket: 'Próximo mercado',
  breakingMarkets: 'Mercados urgentes',
  showBreakingMarket: 'Mostrar mercado urgente {{index}}',
  featuredMarkets: 'Mercados em destaque',
  topMovers: 'Maiores variações',
  viewAll: 'Ver tudo',
  liveTrades: 'Negociações ao vivo',
  live: 'Ao vivo',
  featuredMarket: 'Mercado em destaque',
  untitledMarket: 'Mercado sem título',
  traders: 'Traders',
  endsIn: 'Termina em',
  tradeNow: 'Negociar agora',
  showFeaturedMarket: 'Mostrar mercado em destaque {{index}}',
  openNewsHeadline: 'Abrir notícia: {{headline}}',
  openNewsStatus: 'Abrir notícia: {{statusText}}',
  news: 'Notícias',
  minimizeNews: 'Minimizar notícias',
  expandNews: 'Expandir notícias',
  closeNews: 'Fechar notícias',
  liveWire: 'Plantão ao vivo',
  categoryNews: 'Notícias de {{category}}',
  categoryDesk: 'Editoria {{category}}',
  topHeadlinesAndRelatedCoverage: 'Principais manchetes e cobertura relacionada para esta categoria de mercado',
  topHeadlinesCount: 'Principais {{count}} manchetes',
  moreRelevantNews: 'Mais notícias relevantes',
  noNewsStoriesForThisCategoryYet: 'Ainda não há notícias para esta categoria.',
  pullingHeadlinesFromTheWire: 'Buscando manchetes do plantão…',
  scanningWire: 'Verificando plantão…',
  categoryWaitingForStories: '{{category}} · aguardando notícias',
  categoryStoriesCount: '{{category}} · {{count}} notícias',
  searchMarkets: 'Buscar mercados...',
  searchPortfolioActivity: 'Buscar atividade do portfólio',
  refreshPortfolioActivity: 'Atualizar atividade do portfólio',
  portfolioSections: 'Seções do portfólio',
  noPositionsFound: 'Nenhuma posição encontrada',
  yourOwnedPositionsWillAppearHere: 'Suas posições aparecerão aqui.',
  noOrdersFound: 'Nenhuma ordem encontrada',
  marketOrdersWillAppearInThisSection: 'As ordens a mercado aparecerão nesta seção.',
  limitOrdersWillAppearInThisSection: 'As ordens limitadas aparecerão nesta seção.',
  noActivityYet: 'Ainda sem atividade',
  completedTradesAndSettlementsWillBeListedHere: 'Negociações concluídas e liquidações serão listadas aqui.',
  cancelThisOrder: 'Cancelar esta ordem?',
  cancelThisOrderDescription: 'Isso removerá sua ordem limitada aberta do livro. Você pode enviar uma nova a qualquer momento.',
  keepOrder: 'Manter ordem',
  cancelOrder: 'Cancelar ordem',
  yourTradingDesk: 'Sua mesa de negociação',
  stateFilters: 'Filtros de estado',
  tablePagination: 'Paginação da tabela',
  pagination: 'Paginação',
  previousPage: 'Página anterior',
  nextPage: 'Próxima página',
  noDataAvailable: 'Nenhum dado disponível',
  dataWillAppearHere: 'Os dados aparecerão aqui',
  thumbnail: 'Miniatura',
  actions: 'Ações',
  rowThumbnail: 'Miniatura da linha',
  yourPerformance: 'Seu desempenho',
  walletBalance: 'Saldo da carteira',
  totalProfitIncludingTakerFee: 'Lucro total incluindo taxa taker',
  totalProfit: 'Lucro total',
  hideTakerFee: 'Ocultar taxa taker',
  showTakerFee: 'Mostrar taxa taker',
  profitOverTime: 'Lucro ao longo do tempo',
  noChartDataAvailable: 'Nenhum dado de gráfico disponível',
  profitHistoryWillAppearAsTradesArePlaced: 'O histórico de lucro aparecerá conforme as negociações forem feitas.',
  profitChartTimeRange: 'Intervalo do gráfico de lucro',
  userActivity: 'Atividade do usuário',
  userActivityTitle: 'Atividade do usuário',
  userActivityTabs: 'Abas de atividade do usuário',
  refreshUserActivity: 'Atualizar atividade do usuário',
  addYourComment: 'Adicione seu comentário',
  shareYourThoughtsAboutThisMarket: 'Compartilhe sua opinião sobre este mercado...',
  anonymous: 'anônimo',
  hideReplies: 'Ocultar respostas',
  showReplies: 'Mostrar respostas',
  writeAReply: 'Escreva uma resposta...',
  loadingEllipsis: 'Carregando...',
  recentMarketBuysAndSellsWillAppearHere: 'Compras e vendas a mercado recentes aparecerão aqui.',
  topHolders: 'Principais detentores',
  topPositions: 'Principais posições',
  noTopPositionsFound: 'Nenhuma posição principal encontrada',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'As principais posições com o maior PNL realizado aparecerão aqui',
  yesHolders: 'Detentores Sim',
  noHolders: 'Detentores Não',
  noTopHoldersFoundForYesOutcome: 'Nenhum principal detentor encontrado para o resultado Sim',
  topHoldersWillAppearHereForYesOutcome: 'Os principais detentores do resultado Sim aparecerão aqui',
  noTopHoldersFoundForNoOutcome: 'Nenhum principal detentor encontrado para o resultado Não',
  topHoldersWillAppearHereForNoOutcome: 'Os principais detentores do resultado Não aparecerão aqui',
  optionDetailsTabs: 'Abas de detalhes da opção',
  orderbookOutcome: 'Resultado do livro',
  orderbook: 'Livro de ordens',
  graph: 'Gráfico',
  myPosition: 'Minha posição',
  yesBook: 'Livro Sim',
  noBook: 'Livro Não',
  spread: 'Spread',
  you: 'Você',
  noAsks: 'Sem asks',
  noBids: 'Sem bids',
  loadingPosition: 'Carregando posição...',
  yourOrders: 'Suas ordens',
  marketOrdersForThisOptionWillAppearHere: 'As ordens a mercado desta opção aparecerão aqui.',
  limitOrdersForThisOptionWillAppearHere: 'As ordens limitadas desta opção aparecerão aqui.',
  rulesAndMarketContext: 'Regras e contexto do mercado',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'O mercado é resolvido com base nos critérios listados e nos dados finais do resultado.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'O mecanismo de correspondência liquida ordens abertas usando as regras de resolução do mercado.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Resultados ambíguos são tratados pela política de arbitragem da plataforma.',
  defaultPredictionMarketRules: `
  Regras:
  - Este mercado é resolvido com base no resultado descrito na pergunta. A resolução usará fontes públicas e confiáveis, como declarações oficiais, provedores de dados verificados ou organizações de notícias respeitáveis. 
  - Se o resultado ficar claro antes da data final indicada, o mercado pode ser resolvido antecipadamente. Se o evento não puder ser determinado ou a pergunta ficar ambígua, a plataforma pode resolver o mercado usando o melhor julgamento com base nas informações disponíveis.
  - Todas as resoluções são finais.`,
  pleaseLogInToFavouriteQuestions: 'Faça login para favoritar perguntas.',
  removeFromFavourites: 'Remover dos favoritos',
  addToFavourites: 'Adicionar aos favoritos',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Não foi possível atualizar a pergunta favorita. Tente novamente.',
  marketOrderInProgress: 'Ordem a mercado em andamento',
  noActiveMarketOrder: 'Nenhuma ordem a mercado ativa',
  marketOrderRunning: 'Ordem a mercado em execução',
  remainingAmount: 'Restante: ${{amount}}',
  remainingShares: 'Restante: {{shares}} cotas',
  statusState: 'Status: {{state}}',
  noMarketOrderRunning: 'Nenhuma ordem a mercado em execução. Você encontra ordens a mercado anteriores na aba Ordens da página Portfólio.',
  deposit: 'Depositar',
  withdraw: 'Sacar',
  closeWalletActivityModal: 'Fechar modal de atividade da carteira',
  enterAmountToAction: 'Informe o valor para {{action}}',
  depositSuccessful: 'Depósito realizado com sucesso',
  depositFailedPleaseTryAgain: 'Falha no depósito. Tente novamente.',
  withdrawalSuccessful: 'Saque realizado com sucesso',
  withdrawFailedPleaseTryAgain: 'Falha no saque. Tente novamente.',
  mergeSuccessfulBalanceCredited: 'Mesclagem concluída. Saldo creditado.',
  mergeSuccessfulCreditPending: 'Mesclagem concluída. Crédito pendente — o saldo será atualizado em breve.',
  orderPlacedSuccessfully: 'Ordem enviada com sucesso',
  placeOrderFailedPleaseTryAgain: 'Falha ao enviar a ordem. Tente novamente.',
  orderCancelledSuccessfully: 'Ordem cancelada com sucesso',
  cancelLimitOrderFailedPleaseTryAgain: 'Falha ao cancelar a ordem limitada. Tente novamente.',
  commentAdded: 'Comentário adicionado',
  addCommentFailedPleaseTryAgain: 'Falha ao adicionar comentário. Tente novamente.',
  commentDeleted: 'Comentário excluído',
  deleteCommentFailedPleaseTryAgain: 'Falha ao excluir comentário. Tente novamente.',
  failedToLoadNotifications: 'Falha ao carregar notificações',
  commentCannotBeEmpty: 'O comentário não pode ficar vazio.',
  commentNotFound: 'Comentário não encontrado.',
  demoMultiOutcomeMarket: 'Mercado demo de múltiplos resultados',
  outcomeAlpha: 'Resultado Alfa',
  outcomeBeta: 'Resultado Beta',
  outcomeGamma: 'Resultado Gama',
  greatMarketToLearnLimitOrders: 'Ótimo mercado para aprender ordens limitadas — tente colocar um bid abaixo do preço atual.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'O livro de ordens atualiza ao vivo quando você começa a enviar ordens demo.',
  demoOutcome: 'Resultado demo',
  demoMarketControls: 'Controles do mercado demo',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Simule o fechamento e a liquidação para ver como o mercado se comporta.',
  closePanel: 'Fechar painel',
  closeMarket: 'Fechar mercado',
  tradingOpen: 'Negociação aberta',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Interrompe a negociação, limpa o livro e fecha ordens abertas. Valores pré-pagos restantes em ordens de bid voltam para sua carteira. As posições permanecem abertas até a liquidação.',
  marketClosed: 'Mercado fechado',
  settleMarket: 'Liquidar mercado',
  ready: 'Pronto',
  awaitingClose: 'Aguardando fechamento',
  pickTheWinningOutcomeDescription: 'Escolha o resultado vencedor. Cotas vencedoras pagam US$ 1 cada, as posições são zeradas e as opções aparecem como liquidadas com o resultado final.',
  winningOutcome: 'Resultado vencedor',
  settlementOutcome: 'Resultado da liquidação',
  closeManageMarketPanel: 'Fechar painel de gerenciar mercado',
  manageMarket: 'Gerenciar mercado',
  manageDemoMarket: 'Gerenciar mercado demo',
  noChartDataYet: 'Ainda sem dados de gráfico',
  priceHistoryWillAppearHereAsTradesHappen: 'O histórico de preços aparecerá aqui conforme as negociações acontecerem.',
  chartTimeRange: 'Intervalo do gráfico',
  allMarkets: 'Todos os mercados',
  backToCollateral: 'Voltar para garantia · {{marketTitle}}',
  demo: 'Demo',
  depositing: 'Depositando...',
  equalYesAndNoShares: 'Cotas Sim e Não iguais · {{marketTitle}}',
  estValue: 'Est. {{value}}',
  favouriteQuestions: 'Perguntas favoritas',
  favourites: 'Favoritos',
  feePerShareFormula: 'Taxa por cota (¢) = preço × (100 − preço) × {{coefficient}} / 10,000',
  limitBuy: 'Compra limitada',
  limitSell: 'Venda limitada',
  marketBuyOn: 'Compra a mercado em {{marketTitle}}',
  marketSellOn: 'Venda a mercado em {{marketTitle}}',
  marketResolutionPayoutReceived: 'Pagamento da resolução do mercado recebido. Novo saldo: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Paginação de mercados',
  noFavouriteQuestionsYet: 'Ainda não há perguntas favoritas.',
  noTitle: 'Sem título',
  optionNumber: 'Opção {{number}}',
  postOnlyLimitBuy: 'Compra limitada somente publicação',
  system: 'SISTEMA',
  unknownOrderType: 'Tipo de ordem desconhecido: {{orderType}}',
  withdrawing: 'Sacando...',
  yourBalanceWasCredited: 'Seu saldo foi creditado. Novo saldo: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Seu saldo foi debitado. Novo saldo: {{currency}} {{formattedBalance}}',
  thisMarket: 'este mercado',
  yourPositionText: 'sua posição',
  amountYesAndNo: '{{amount}} Sim + {{amount}} Não',
  daysAgo: 'há {{days}} d',
  hoursAgo: 'há {{hours}} h',
  minutesAgo: 'há {{minutes}} min',
  outcomeSharesAtMarket: 'cotas {{outcome}} a mercado',
  sharesYesAndNo: '{{shares}} Sim + {{shares}} Não',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} cotas {{outcome}}'
}


/**
 * NOTE:
 * =================================================================================================
 * Please go through this spreading objects first before adding new translation key. So that the
 * duplicate translations will not be created and help us to maintain the consitency of code.
 * If you didn't find any of translation as per your requirement in reserve or api success & error
 * msg translation object, Please add new translation with unique key name in otherTranslationKeys
 * Object. Unique key names help us to avoid overriding of translations.
 * =================================================================================================
 */
export default {
  ...en,
  ...reservedTranslationsWithUniqueKeyNames,
  ...apiSuccessMessagesTranslations,
  ...apiErrorMessagesTranslations,
  ...otherTranslationKeys,
  ...predictionMarketTranslations
}
